<template>
    <div class="mx-auto h-full w-full max-w-9xl p-3 md:p-4 lg:p-8">
        <!-- Optional heading slot -->
        <div v-if="$slots.heading">
            <slot name="heading" />
        </div>
        <div class="flex h-full flex-col lg:flex-row lg:gap-6">
            <!-- Sidebar -->
            <aside class="w-full lg:w-72 flex-shrink-0">
                <slot name="sidebar" />
            </aside>

            <!-- Main Content -->
            <main class="flex-1 overflow-hidden">
                <slot name="main" />
            </main>
        </div>
    </div>
</template>